type NotificationType = 'success' | 'error' | 'warning' | 'info';

export interface Notification {
  type: NotificationType;
  message: string;
}

interface State {
  notifications: Notification[];
}

class NotificationStore {
  state: State = {
    notifications: [],
  };
  private listeners: Set<(state: State) => void> = new Set();

  subscribe = (callback: (state: State) => void) => {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  };

  getSnapshot = () => {
    return this.state;
  };

  success(message: string) {
    this.addNotification({ type: 'success', message });
  }

  error(message: string) {
    this.addNotification({ type: 'error', message });
  }

  info(message: string) {
    this.addNotification({ type: 'info', message });
  }

  warning(message: string) {
    this.addNotification({ type: 'warning', message });
  }

  flush() {
    this.state = {
      ...this.state,
      notifications: [],
    };
    this.notify();
  }

  private addNotification(notification: Notification) {
    this.state = {
      ...this.state,
      notifications: [...this.state.notifications, notification],
    };
    this.notify();
    this.scheduleDismiss(notification);
  }

  private scheduleDismiss(notification: Notification) {
    setTimeout(() => {
      this.state = {
        ...this.state,
        notifications: this.state.notifications.filter((n) => n !== notification),
      };
      this.notify();
    }, 2000);
  }

  private notify() {
    this.listeners.forEach((listener) => {
      listener(this.state);
    });
  }
}

const notificationStore = new NotificationStore();
export default notificationStore;
